<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav">
      <!-- 导航logo -->
      <div class="header-nav-logo" id="header-nav-logo"></div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as auth from "../utils/auth";
import {userInfo} from "../api/shop";

export default {
  name: "Header",
  data() {
    return {
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList:[],
      cNavList:[
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "兑换",
          path: "/service",
          children: []
        }],
      userInfo: {}
    };
  },
  created() {
    userInfo({}).then(res => {
      if(res.data)
        this.userInfo = res.data;
        setInterval(()=>{
          this.reload();
        },1000);
    }).catch(()=>{
      this.reload();
    });
    setInterval(()=>{
      this.resize();
    },500);

    window.addEventListener('resize', ()=>{
      console.log("resize............")
      this.resize();
    });
  },
  methods: {
    resize(){
      if(this.isMobile()){
        $(".pc-banner .button").show();
        $("#header .header-nav .header-nav-wrapper > li > a").css("font-size","12px");
        $("#header .header-nav .header-nav-wrapper").css("margin-right","10px");
      }else{
        $(".pc-banner .button").hide();
        $("#header .header-nav .header-nav-wrapper > li > a").css("font-size","20px");
        $("#header .header-nav .header-nav-wrapper").css("margin-right","30px");
      }
    },
    navClick(index, name,path) {
        this.menuName = name;
        //location.href = "/#" + path;
        this.$router.replace(path).catch(()=>{});
    },
    reload(){
      this.navList = [];
      if(auth.isLogin()){
        this.navList.push(...this.cNavList,...[
          {
            name: "兑换记录",
            path: "/exchangeLog",
            children: []
          },
          {
            name: "收货地址",
            path: "/addressList",
            children: []
          },
          {
            name: "(" + this.userInfo.nickname + ")退出",
            path: "/logout",
            children: []
          }
        ])
      }else{
        this.navList.push(...this.cNavList,{
          name: "登录",
          path: "/login",
          children: []
        });
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
  position: relative;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  position: absolute;
  top: 20px;
  left: 5px;
  width: 383px;
  height: 65px;
  background-image: url("../assets/img/logo_black_big.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 5px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 12px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}

/* 当视口宽度小于等于997px时，设置body的背景颜色为淡紫色 */
@media screen and (max-width: 997px) {
  #header .header-nav .header-nav-logo {
    position: absolute;
    top: 30px;
    left: 5px;
    width: 50px;
    height: 50px;
    background-image: url("../assets/img/logo_black.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue